import { USER_STORAGE_KEY } from "./constants";

export const logout = () => {
  localStorage.removeItem(USER_STORAGE_KEY);
  localStorage.removeItem("page-index");
  window.location.href = "/login";
};
